import { useEffect, useRef } from "react";
import type { TrainingMetrics } from "../api/ml";

/** The log view (QTextEdit#logView), kept scrolled to the end, with the run's epoch progress above it. */
export function JobLog({ log, metrics, testId, collapsible = false }: {
  log: string; metrics: TrainingMetrics | null; testId: string;
  /** The Train page shows progress and keeps the raw log behind "Training log", and nothing at all before a run. */
  collapsible?: boolean;
}) {
  const ref = useRef<HTMLPreElement>(null);
  useEffect(() => { const el = ref.current; if (el) el.scrollTop = el.scrollHeight; }, [log]);
  const last = metrics?.epochs.at(-1);
  return (
    <>
      {last && (
        <div className="muted" style={{ marginBottom: 6 }} data-testid={`${testId}-epochs`}>
          <div className="progress" style={{ marginBottom: 4 }}>
            <i style={{ width: `${last.total_epochs ? (last.epoch / last.total_epochs) * 100 : 0}%` }} /><span>Epoch {last.epoch} / {last.total_epochs}</span>
          </div>
          {last.loss !== null && <>loss {last.loss.toFixed(3)}</>}
          {last.map50 !== null && <> · mAP50 {last.map50.toFixed(3)}</>}
          {metrics?.summary.best_map50 !== undefined && <> · best mAP50 {metrics.summary.best_map50.toFixed(3)}</>}
          {metrics?.summary.seconds_per_epoch !== undefined && <> · {metrics.summary.seconds_per_epoch.toFixed(1)} s/epoch</>}
        </div>
      )}
      {collapsible
        ? log && <details className="log-details"><summary>Training log</summary><pre className="logview" ref={ref} data-testid={testId}>{log}</pre></details>
        : <pre className="logview" ref={ref} data-testid={testId}>{log}</pre>}
    </>
  );
}
